<template>
	<div>
		<div class="section-title">
			<i class="label-icon" :class="meta.icon"></i>
			<span class="label-text">{{ meta.title }}</span>
			<span class="ml-2 text-bold">
				<router-link
					:to="{ path: '/suppliers' }"
					class="text-decoration-none"
				>Lihat semua</router-link>
			</span>
		</div>
		<div class="row supplier-cards">
			<template v-if="isFetchingSuppliers && page === 1">
				<div v-for="(supplier, index) in dummySuppliers" :key="'dummy1-'+index" class="col-xl-2 col-lg-3 col-md-4 col-6 d-flex justify-content-center supplier-card">
					<supplier-card :is-loading="isFetchingSuppliers" />
				</div>
			</template>
			<template>
				<template v-if="suppliers.length > 0">
					<div v-for="(supplier, index) in suppliers" :key="'supplier-'+index" class="col-xl-2 col-lg-3 col-md-4 col-6 d-flex justify-content-center supplier-card">
						<supplier-card :supplier="supplier" @showDetail="showDetail(supplier)" />
					</div>
					<template v-if="isFetchingSuppliers">
						<div v-for="(supplier, index) in dummySuppliers" :key="'dummy2-'+index" class="col-xl-2 col-lg-3 col-md-4 col-6 d-flex justify-content-center supplier-card">
							<supplier-card :is-loading="isFetchingSuppliers" />
						</div>
					</template>
				</template>
				<template v-else>
					<div class="col-12">
						<div class="card card-body card-supplier-empty border-0 d-flex mb-4">
							<div class="empty-description">
								Oops, data supplier tidak ditemukan.
							</div>
						</div>
					</div>
				</template>
			</template>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import SupplierCard from '@/components/SupplierCard.vue';
import homepageApi from '@/api/homepage';
import {
	formatNumber,
	formatMoney,
	duplicateVar,
} from '@/lib/helper';

export default {
	name: 'Suppliers',
	components: {
		SupplierCard,
	},
	props: {
		meta: {
			type: Object,
		},
	},
	data() {
		return {
			keyword: '',
			limit: 6,
			page: 1,
			totalPages: 0,
			totalItems: 0,
			itemsPerPage: 8,
			scrollAmount: 0,
			arrowRight: true,
			dummySuppliers: new Array(6),
			suppliers: [],
			isFetchingSuppliers: true,
		};
	},
	methods: {
		duplicateVar,
		formatNumber(number) {
			return formatNumber(number, 0, ',', '.');
		},
		formatMoney,
		showDetail(supplier) {
			const encodedUserId = window.btoa(supplier.user._id.$oid);
			this.$router.push({ name: 'supplier-detail', params: { slug: `${supplier.slug}-${encodedUserId}` } });
		},
		fetchSuppliers(reset = false) {
			this.isFetchingSuppliers = true;

			const params = {
				limit: this.limit,
				page: this.page,
			};

			const callback = (response) => {
				const data = response.data;
				// console.log('Fetched suppliers:', data.suppliers);
				if (reset) {
					this.suppliers = data.suppliers;
				} else {
					this.suppliers = [...this.suppliers, ...data.suppliers];
				}

				this.page = data.page_info.current_page;
				this.totalPages = data.page_info.last_page;
				this.totalItems = data.page_info.total_all_suppliers;
				this.isFetchingSuppliers = false;
			};

			const errorCallback = (e) => {
				console.log('Error fetching suppliers', e);
				this.suppliers = [];
				this.page = 1;
				this.totalPages = 0;
				this.totalItems = 0;
				this.isFetchingSuppliers = false;
			};

			homepageApi.getPublicSuppliers(params, callback, errorCallback);
		},
		showAllsupplier() {
			this.$router.push({ path: '/suppliers' });
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
	},
	watch: {
		user() {
			this.fetchSuppliers(true);
		},
	},
	mounted() {
		if (this.meta.source !== 'static') {
			this.fetchSuppliers();
		}
	},
};
</script>
<style lang="scss" scoped>
	@import '../../../assets/scss/modules/_variables.scss';

	.section-title {
		// margin-left: 40px;
		margin-bottom: 10px;
		.label-icon {
			font-size: 32px;
			color: #D66956;
			margin-right: 20px;
		}
		.label-text {
			font-style: normal;
			font-weight: 600;
			font-size: 28px;
			color: #4D4D4D;
		}
	}

	.category-nav {
		margin-left: 20px;
		margin-right: 10px;
		margin-bottom: 15px;
		overflow-x: scroll;
		overflow-y: hidden;
		white-space: nowrap;
		&::-webkit-scrollbar { width: 0 !important }

		div {
			display: inline-block;
			margin-right: 20px;
			padding-left: 20px;
			padding-right: 20px;
			cursor: pointer;

			span {
				color: rgba(27, 28, 30, 0.87);
				text-align: center;
				padding-top: 14px;
				padding-bottom: 14px;
				padding-left: 10px;
				font-size: 16px;
				font-weight: 700;
			}

			img {
				margin-bottom: 7px;
			}

			&:hover {
				border-bottom: 2px solid $color__primary;
			}

			&.active {
				border-bottom: 2px solid $color__primary;
			}
		}
	}

	.category-next {
		margin-left: 40px;
		margin-right: 50px;
		cursor: pointer;
		font-size: 1.4em;

		@media screen and (max-width: 540px) {
			margin-left: 0px;
			margin-right: 10px;
		}
	}

	.card-supplier-empty {
		border-radius: 5px;
		padding: 30px;
	}

	.pc-box {
		&.box {
			border-radius: 5px;
			overflow: hidden;
		}
	}

	.supplier-card {
		padding-left: 8px;
		padding-right: 8px;
	}
	.row.supplier-cards {
		margin-left: -8px;
		margin-right: -8px;
	}
</style>
